module.exports = __webpack_public_path__ + "static/media/ziegelofen.c7e1e15a.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Sizilien/ziegelofen.JPG
// module id = 783
// module chunks = 0